module.exports = "::ng-deep .col-md-9 {\n  position: sticky;\n  top: 152px; }\n\n::ng-deep .buttons {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n::ng-deep .buttons .button-one {\n    margin-right: 10px; }\n\n::ng-deep .scroll-tab {\n  margin-top: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/media-plan/media-plan.component.scss
// module id = ./src/app/pages/media-plan/media-plan.component.scss
// module chunks = main